import { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { getFlowRoute } from 'automation-ui-routing/utils';
import { basePaths } from 'automation-ui-canvas/constants/Routes';
import { getClassicWorkflowMigrationStatusById } from 'automation-ui-canvas/data/api/FlowsApi';
import LoadingError from 'automation-ui-canvas/components/errors/LoadingError';
import { jsx as _jsx } from "react/jsx-runtime";
const ClassicWorkflowRedirect = ({
  match: {
    params: {
      workflowId
    }
  }
}) => {
  const [isStatusLoading, setIsStatusLoading] = useState(true);
  const [flowId, setFlowId] = useState(NaN);
  useEffect(() => {
    getClassicWorkflowMigrationStatusById(+workflowId).then(res => res && setFlowId(res.flowId)).catch(() => {}) // ignore, suppress sentry
    .finally(() => setIsStatusLoading(false));
  }, [workflowId]);
  if (isStatusLoading) {
    return /*#__PURE__*/_jsx(UILoadingOverlay, {});
  } else if (isNaN(flowId)) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "WORKFLOW_NOT_FOUND",
      children: /*#__PURE__*/_jsx(LoadingError, {
        error: 404
      })
    });
  } else {
    return /*#__PURE__*/_jsx(Redirect, {
      path: "*",
      to: `${getFlowRoute(flowId)}/${basePaths.EDIT}`
    });
  }
};
export default ClassicWorkflowRedirect;